import { Payload } from 'recharts/types/component/DefaultTooltipContent';

export type AggregationType = 'sum' | 'max';

export function aggregatePayload(payload: Payload<number, string>[] | undefined, operation: AggregationType): number {
  if (!payload) return 0;

  const values = payload.map((item) => item.value).filter((value): value is number => value !== undefined);

  if (operation === 'sum') {
    return values.reduce((total, value) => total + value, 0);
  } else if (operation === 'max') {
    return values.length > 0 ? Math.max(...values) : 0;
  }

  return 0;
}
